<template>
  <div>
    <Top />
    <div class="mianbox">
      <div class="pub yahei">
        <div style="margin:10px 20px;">
          <p
            style="font-size:22px;color:#2e51b5;font-weight:bold; padding:10px 28px; background-color:#f5f5f5; text-align:center"
          >国研网“一带一路”研究与决策平台简介</p>
          <p style="text-indent:2em;margin-top:20px;font-size:17px;">
            <strong>一、开发背景</strong>
          </p>
          <p
            style="text-indent:2em"
          >2013年9月和10月，习近平总书记在出访中亚和东南亚国家期间，先后提出了共建“丝绸之路经济带”和“21世纪海上丝绸之路”（以下简称“一带一路”）的重大倡议，随后该倡议被写入十八届三中全会《决定》，正式上升为国家战略，这一跨越时空的战略构想一提出便引起了国内外的高度关注和强烈共鸣。</p>
          <p
            style="text-indent:2em"
          >9年多来，“一带一路”朋友圈不断扩大，成果超出预期。截至2023年初，我国已与151个国家、32个国际组织签署200多份共建“一带一路”合作文件。截至2022年底，中欧班列联通中国境内108个城市，通达欧洲约25个国家的200多个城市，累计开行突破6.5万列，发送604万标箱，货值3000亿美元。2022年，中国与“一带一路“沿线国家和地区对外货物贸易规模创历史新高，货物贸易额达13.8万亿元，同比增长19.4%，占中国外贸总额的比重达32.9%。2022年中国对沿线国家非金融类直接投资1410.5亿元，同比增长7.7%，占同期对外投资总额的比重达17.9%。</p>
          <p
            style="text-indent:2em"
          >显然，“一带一路”建设会给国内以及沿线国家和地区带来重大机遇，但与此同时，也会给国内外参与者带来一定的风险和挑战。当前，“一带一路”建设项目正加速落地，但国内有关“一带一路”沿线国家和地区深入、系统和全面研究的高质量数据库付之阙如，对沿线国家和地区的语言和文化、历史和政治、经济和人口等的研究和认识都较为模糊和碎片化。要全面实现“一带一路”战略所设想的“政策沟通、设施联通、贸易畅通、资金融通、民心相通”愿景，必须保持信息全面畅通。为此，国研网将着眼于服务“一带一路”倡议，利用自身专业经验和国际信息网络，于2015年率先推出了国研网“一带一路”研究与决策平台，并在后期根据形势变化持续进行完善和升级，为用户全方位提供沿线国家和地区有关政经形势、政策法规、营商环境、投资案例、宏观数据、国别风险等报告和信息，深度剖析“一带一路”沿线国家和地区的潜在机遇与挑战，努力把中国的需求与沿线各国的发展需要有效对接起来，帮助国内企业进行短期、中期、长期战略规划，助力国内企业顺利“走出去”、“走得稳”、“留得住”和“叫得响”，并为我国各级政府部门和专家学者提供高质量的系统研究资料和决策参考。</p>
          <p style="text-indent:2em; margin-top:20px; font-size:17px;">
            <strong>二、平台栏目设置及内容定位</strong>
          </p>
          <p style="text-indent:2em">
            为了满足多用户需求，同时为了给后期国研网“一带一路”研究与决策平台的迭代留有空间，结合理论研究和实际需求，平台设8大主栏目 
            <strong>（报告、案例、法规、项目、园区、科技人文、指数、数据）、4</strong>大辅助栏目
            <strong>（动态、规划方案、机构和重点报告推荐），</strong>同时设置了
            <strong>国别、省市</strong>标签，方便自动实现聚合分类（表1）。目前，平台涵盖了154个国家和地区、82个境外经贸合作园区。
          </p>

          <p
            style="text-align:center;padding-top:20px; padding-bottom:20px;font-weight:700;"
          >表1 国研网“一带一路”研究与决策平台栏目架构及内容定位</p>
          <div align="center">
            <table width="90%" cellspacing="0" cellpadding="0">
              <tbody>
                <tr>
                  <td rowspan="9" width="15%" bgcolor="#e9e9e9">
                    <br />
                    <p style="text-align:center">
                      <strong>主要栏目</strong>
                    </p>
                  </td>
                  <td width="25%" bgcolor="#e9e9e9">
                    <p style="text-align:center">
                      <strong>一级栏目</strong>
                    </p>
                  </td>
                  <td width="25%" bgcolor="#e9e9e9">
                    <p style="text-align:center">
                      <strong>二级栏目</strong>
                      <strong></strong>
                    </p>
                  </td>
                  <td width="35%" valign="top" bgcolor="#e9e9e9">
                    <p style="text-align:center">
                      <strong>内容定位</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">报告</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;国别形势</li>
                      <li>◆&nbsp;营商报告</li>
                      <li>◆&nbsp;投资指南&nbsp;</li>
                      <li>◆&nbsp;贸易投资报告</li>
                      <li>◆&nbsp;丝路战略研究</li>
                      <li>◆&nbsp;国家风险评估</li>
                      <li>◆&nbsp;行业报告</li>
                      <li>◆&nbsp;一带一路国家形势报告</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p
                      style=" padding:10px;"
                    >全方位、多层次梳理“一带一路”相关战略研究以及国内外地区及国家投资环境、经济发展形势、投资营商政策等，为相关学术研究、投资规划及投资决策提供强有力的决策支持</p>
                  </td>
                </tr>
                <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">案例</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;按行业分</li>
                    </ul>
                    <ul style="padding:0px 20px 10px 20px; font-size:14px; line-height:170%; ">
                      <li>－农业</li>
                      <li>－能源矿产</li>
                      <li>－基础设施</li>
                      <li>－信息通信</li>
                      <li>－制造业</li>
                      <li>－服务业</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p style=" padding:10px;">为国内企业“走出去”提供经典案例分析，帮助中国企业“走得出”“走得好”“留得住”</p>
                  </td>
                </tr>
                <!-- <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">行业</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:170%; ">
                      <li>◆&nbsp;农业</li>
                      <li>◆&nbsp;能源矿产</li>
                      <li>◆&nbsp;信息通信</li>
                      <li>◆&nbsp;基础设施</li>
                      <li>◆&nbsp;制造业</li>
                      <li>◆&nbsp;服务业</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p style=" padding:10px;">集中呈现“一带一路”沿线国家和地区上述六大行业发展现状、竞争格局、对外资的管制等深度分析报告</p>
                  </td>
                </tr> -->
                <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">法规</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;“走出去”政策法规</li>
                      <li>◆&nbsp;国际营商政策法规</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p style=" padding:10px;">全面整理东道国与贸易、投资及营商相关的政策以及法律法规</p>
                  </td>
                </tr>
                <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">项目</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;工程招标</li>
                      <li>◆&nbsp;投资项目</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p
                      style=" padding:10px;"
                    >详细、全面地发布国际工程招标信息及重大投资项目信息，为国内企业参与国际工程建设以及进行国际投资提供有价值的项目信息</p>
                  </td>
                </tr>
                <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">园区</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;园区概况</li>
                      <li>◆&nbsp;园区动态</li>
                      <li>◆&nbsp;园区规划</li>
                      <li>◆&nbsp;园区研究</li>
                      <li>◆&nbsp;入园指南</li>
                      <li>◆&nbsp;入驻企业</li>
                      <li>◆&nbsp;重大项目</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p
                      style=" padding:10px;"
                    >系统收集了中国企业在“一带一路”国家已经建成和正在招商引资的国家级和省市级跨境经贸合作园区，为国内企业抱团出海、集群式“走出去”提供有益参考和投资机会。</p>
                  </td>
                </tr>

                <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px;">科技人文</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;科技</li>
                      <li>◆&nbsp;文教卫</li>
                      <li>◆&nbsp;旅游</li>
                      <li>◆&nbsp;城市</li>
                      <li>◆&nbsp;智库</li>
                    </ul>
                  </td>
                  <td style="text-align:left;" width="32%" valign="top">
                    <p
                      style=" padding:10px;"
                    >收录“一带一路”国家和地区在科技、教育、文化、卫生、旅游、政党、智库、青年、城市、社会组织等各领域合作深度分析报告</p>
                  </td>
                </tr>

                <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px;">指数</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;“一带一路”航贸指数</li>
                      <li>◆&nbsp;海上丝路贸易指数</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p
                      style=" padding:10px;"
                    >整合“一带一路”相关指数，便于用户动态监测带路国家的贸易投资形势，如“一带一路”航贸指数、海上丝路贸易指数等</p>
                  </td>
                </tr>

                <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">数据</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;经济社会数据</li>
                      <!-- <li>◆&nbsp;能源矿产</li> -->
                      <li>◆&nbsp;中国全球投资跟踪（CGIT）数据</li>
                      <li>◆&nbsp;中国对外贸易数据</li>
                      <li>◆&nbsp;政治数据</li>
                      <li>◆&nbsp;营商环境指数</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p style=" padding:10px;">
                      全面提供“一带一路”国家和地区主要经济指标、进出口、国外直接投资、基础设施指标、人口结构、
                      <span>中国全球投资跟踪（CGIT）数据、政治数据、营商环境数据等，并以可视化方式展现</span>
                    </p>
                  </td>
                </tr>
                <!-- <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">图表</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;矿产分布图</li>
                      <li>◆&nbsp;其它图表</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p style=" padding:10px;">收录“一带一路”国家和地区相关矿业、投资、营商、发展等图表</p>
                  </td>
                </tr> -->
                <tr>
                  <td rowspan="4" width="9%" bgcolor="#e9e9e9">
                    <p style="text-align:center">
                      <strong>辅助栏目</strong>
                    </p>
                  </td>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">动态</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;丝路动态</li>
                    </ul>
                    <ul style="padding:0px 20px 10px 20px; font-size:14px; line-height:170%; ">
                      <li>－高层声音</li>
                      <li>－地方举措</li>
                      <li>－行业参与</li>
                      <li>－专家视点</li>
                      <li>－海外合作</li>
                      <li>－带路成就</li>
                    </ul>
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;政经动态</li>
                    </ul>
                    <ul style="padding:0px 20px 10px 20px; font-size:14px; line-height:170%; ">
                      <li>－国内动态</li>
                      <li>－国际动态</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p style=" padding:10px;">
                      全面整合与丝路相关的政策、动态、地方行动、专家评论，并及时汇聚“一带一路”所涉国家和地区的政经动态精华，重点关注最新政经动态、国际贸易动向，提供专业财经动态。
                      <span>与此同时，栏目还及时跟踪六年来“一带一路”建设所取得的标志性成就。</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">规划方案</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:35px; ">
                      <li>◆&nbsp;总体规划</li>
                      <li>◆&nbsp;地方方案</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p style=" padding:10px;">收录“一带一路”总体规划及各省市（自治区）的实施方案</p>
                  </td>
                </tr>
                <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">机构</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <ul style="padding:10px 20px; font-size:16px; line-height:170%; ">
                      <li>◆&nbsp;投资管理机构</li>
                      <li>◆&nbsp;投资促进机构</li>
                      <li>◆&nbsp;金融机构</li>
                      <li>◆&nbsp;咨询机构</li>
                      <li>◆&nbsp;法院与仲裁机构</li>
                      <li>◆&nbsp;中国驻外使领馆</li>
                      <li>◆&nbsp;商会</li>
                      <li>◆&nbsp;协会</li>
                      <li>◆&nbsp;其它政府机构</li>
                    </ul>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p
                      style=" padding:10px;"
                    >及时全面提供与“一带一路”国家和地区贸易、投资相关的9大类重要服务机构名录及实用网站链接，为国内企业走出去提供实用指南</p>
                  </td>
                </tr>
                <!-- <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">大事记</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <p>&nbsp;</p>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p style=" padding:10px;">对“一带一路”战略提出以来的重要节点进行梳理，以时间轴展现“一带一路”节点</p>
                  </td>
                </tr> -->
                <tr>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">重点报告推荐</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <p>&nbsp;</p>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p style=" padding:10px;">精心挑选国际组织、全球智库等国内外机构发布的相关旗舰报告</p>
                  </td>
                </tr>
                <tr>
                  <td width="9%" bgcolor="#e9e9e9">
                    <p>&nbsp;</p>
                  </td>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">国别</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <p>&nbsp;</p>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p style=" padding:10px;">为一带一路沿线约154个国家和地区设聚合分类标签</p>
                  </td>
                </tr>
                <tr>
                  <td width="9%" bgcolor="#e9e9e9">
                    <p>&nbsp;</p>
                  </td>
                  <td width="20%">
                    <p style="text-align:center;font-size:16px">省市</p>
                  </td>
                  <td style="text-align:left" width="32%">
                    <p>&nbsp;</p>
                  </td>
                  <td style="text-align:left" width="32%" valign="top">
                    <p style=" padding:10px;">为国内31个省市（自治区）以及港澳台地区设聚合分类标签</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <div
            style="color:red;text-align:left;margin: 10px 55px;font-size: 16px;"
          >注：标红部分为2020年3月新增内容。</div> -->
          <p style="text-indent:2em; padding-top:20px; font-size:17px; text-align:left">
            <strong>三、特色数据集介绍</strong>
          </p>
          <p style="text-indent:2em; padding-top:20px; font-size:17px; text-align:left">
            <strong>1、中国全球投资跟踪（CGIT）数据库</strong>
          </p>
          <p
            style="text-indent:2em;"
          >“中国全球投资追踪”（CGIT）数据库包含2005年至今投资额在1亿美元以上的大型投资项目和工程信息，数据涵盖农业（agriculture）、化工（Chemicals）、能源（Energy）、文娱（Entertainment）、金融（Finance）、卫生（Health）、物流（Logistics）、金属（Metals）、房地产（Real Estate）、科技（Technology）、旅游（Tourism）、交通运输（Transport）、公用事业（Utilities）等13大行业，每一项投资数据都包含投资的时间、投资者、投资金额、行业、地区、国家等9个字段。另外该数据库还包含投资失败项目的相关数据，这是研究中国对外直接投资不可多得的基于微观项目的FDI数据库。</p>
          <p style="text-indent:2em;">更新频率：半年。</p>
          <p style="text-indent:2em; padding-top:20px; font-size:17px; text-align:left">
            <strong>2、中国对外贸易数据</strong>
          </p>
          <p style="text-indent:2em; ">数据来源：中国海关总署</p>
          <p style="text-indent:2em; ">数据频率：月</p>
          <p style="text-indent:2em; ">起始时间：2001年01月</p>
          <p style="text-indent:2em; ">货源地收货地：全国、省级行政区</p>
          <p style="text-indent:2em; ">贸易伙伴：与中国有货物贸易往来的各个国家</p>
          <p style="text-indent:2em; ">贸易方式：二十多种</p>
          <p style="text-indent:2em; ">贸易商品：总额</p>
          <p style="text-indent:2em; ">贸易流向：进口、出口、进出口</p>
          <p style="text-indent:2em; ">指标：数量、金额（美元、人民币）。</p>
          <p style="text-indent:2em; padding-top:20px; font-size:17px; text-align:left">
            <strong>3、政治数据库</strong>
          </p>
          <p
            style="text-indent:2em; "
          >政治数据库”包括人口构成、选举方式、执行方式、政府规模、贪腐程度、武力冲突、法治程度、政策执行、言论自由等九大领域的数百个指标，该数据库具有如下特点：一是数据时间序列较长，绝大部分数据可追溯至1970年；二是数据可横行纵向对比。</p>
          <p style="text-indent:2em;">更新频率：不定期。</p>

          <p style="text-indent:2em; padding-top:20px; font-size:17px; text-align:left">
            <strong>4、营商环境数据</strong>
          </p>
          <p
            style="text-indent:2em; "
          >该数据库涵盖了2004-2020年190个经济体影响企业营商的10个指标：开办企业（Starting a business）、办理施工许可证（Dealing with construction permits）、获得电力（Getting electricity）、登记财产（Registering property）、获得信贷（Getting credit）、保护少数投资者（Protecting minority investors）、纳税（Paying taxes）、跨境贸易（Trading across borders）、执行合同（Enforcing contracts）、办理破产（Resolving insolvency），是研究带路国家营商环境的高质量数据集。</p>
          <p style="text-indent:2em;">更新频率：年度。</p>

          <p style="text-indent:2em; padding-top:20px; font-size:17px; text-align:left">
            <strong>四、平台特色</strong>
          </p>
          <p style="text-indent:2em;">国研网“一带一路”研究与决策平台有四大特色：</p>
          <p style="text-indent:2em;">
            一是
            <strong>技术领先</strong>。平台采用人工智能、大数据等现代信息技术，为用户提供包括推荐算法、智能制图、大屏主题可视化展示等服务，大幅提升用户体验。
          </p>
          <p style="text-indent:2em;">
            二是
            <strong>内容前沿</strong>。平台全面整合国内外顶尖研究机构新近发布的“一带一路”高质量研究成果，可以帮助用户全面把握全球带路研究的前沿研究方向，此外，平台还构建了全球政治数据库以及中国对外直接投资数据库等特殊数据库，为用户的带路研究和投资决策提供了高质量指引。
          </p>
          <p style="text-indent:2em;">
            三是
            <strong>信源权威</strong>。平台整合的高质量研究成果主要来源于全球顶尖智库、世界银行等全球性及亚开行等区域性国际组织、国际知名咨询公司以及国内领先智库和权威期刊，从而确保了报告质量。
          </p>
          <p style="text-indent:2em;">
            四是
            <strong>更新快速</strong>。平台每日更新，确保用户第一时间能获取高质量的有关“一带一路”研究、建设的新进展和信息。
          </p>
          <p style="text-indent:2em; padding-top:20px; font-size:17px; text-align:left">
            <strong>五、产品价值</strong>
          </p>
          <p style="text-indent:2em; ">1、为各级政府部门相关战略决策、政策制定和政策研讨提供智力支持；</p>
          <p style="text-indent:2em; ">2、为各类科研院所的相关学术研究提供深入、系统的高端学术参考；</p>
          <p style="text-indent:2em; ">3、为国内企业“走出去”实时提权威市场情报和投资指南，引领中国企业“走出去”；</p>
          <p style="text-indent:2em; ">4、为信息服务机构资源采购提供上佳的高端信息平台。</p>
        </div>
      </div>
    </div>
    <!-- 右侧联系方式  -->

    <rightnav></rightnav>
    <Footer />
  </div>
</template>
<script>
import Top from "@/components/top";
import Footer from "@/components/footer";
import rightnav from "@/components/rightnav";

export default {
  components: {
    Top,
    Footer,
    rightnav
  }
};
</script>
<style lang="less" scoped>
/deep/.guides {
  display: none !important;
}
.yahei {
  font-family: "Microsoft YaHei";
}
.mianbox {
  width: 1230px;
  margin: 0 auto;
  background-color: #fff;
  margin-top: 10px;
  padding-top: 2px;
}
.mianbox .pub {
  margin: 0 3.5%;
  padding: 4% 0;
}
p {
  text-align: left;
  line-height: 24px;
}
table {
  border: 1px solid;
}
td {
  border: 1px solid;
}
p {
  margin: 5px 0px;
}
</style>